module.exports = __webpack_public_path__ + "img/4.4c4a2458.svg";